export const allPermissions = {
  configureAccount: {
    code: 1000,
    name: 'Super Admin Permission',
  },
  configureRoles: {
    code: 1,
    name: 'Manage Roles',
  },
  configureUsers: {
    code: 2,
    name: 'Manage Users',
  },
  viewUsers: {
    code: 3,
    name: 'View Users',
  },
  configureGroups: {
    code: 4,
    name: 'Manage all groups',
  },
  // Publish solutions
  publishModules: {
    code: 7,
    name: 'Publish Solutions',
  },
  // Edit all solutions
  editModules: {
    code: 8,
    name: 'Edit All Solutions',
  },
  // Create Solution
  editOwnModules: {
    code: 19,
    name: 'Create New Solutions',
  },
  // NOTE(James): May be needed in the future
  licenceModules: {
    code: 9,
    name: 'License Modules',
  },
  viewModules: {
    code: 10,
    name: 'View All Modules',
  },

  manageTeams: {
    code: 13,
    name: 'Manage all project teams',
  },

  // Database Permissions
  createDatabases: {
    code: 201,
    name: 'Create New Databases',
  },
  manageDatabases: {
    code: 202,
    name: 'Manage All Databases',
  },

  // AI permissions
  createAiAssistant: {
    code: 31,
    name: 'Create new AI Agent',
  },

  // Matter
  matterAgentPermissions: {
    code: 32,
    name: 'Agent Permissions',
  },
  matterAdminPermissions: {
    code: 33,
    name: 'Admin Permissions',
  },

  // Nolonger used
  assignModulesToTeams: {
    code: 14,
    name: 'Assign Modules to Teams',
  },
  viewUsersTeams: {
    code: 15,
    name: 'View Users in Teams',
  },

  createTeams: {
    code: 24,
    name: 'Create new project teams',
  },

  // No longer used
  // TEAM LEVEL PERMISSIONS
  viewProjects: {
    code: 16,
    name: 'View All Assessments',
  },
  reviewProjects: {
    code: 17,
    name: 'Team Owner',
  },
  viewOwnProjects: {
    code: 18,
    name: 'View Own Assessments',
  },

  teamMember: {
    name: 'Member',
    code: 'member',
  },

  teamAdmin: {
    name: 'Team Owner',
    code: 'owner',
  },
} as const;

export const groupPermissions = [
  allPermissions.teamMember,
  allPermissions.teamAdmin,
] as const;

export default allPermissions;
